import './src/polyfills.ts';
import '@angular/localize/init';